import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTimer = () => {
  return (
    <g>
      <path d="M9.75 0a.75.75 0 1 1 0 1.5h-1v.54a7.001 7.001 0 1 1-1.5 0V1.5h-1a.75.75 0 0 1 0-1.5h3.5zM8 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zm3.224 2.526a.75.75 0 0 1 .073.976l-.073.084L9.842 8.47a2 2 0 1 1-1.06-1.06l1.382-1.383a.75.75 0 0 1 1.06 0zM8 8.75a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm5.14-7.192c.513.344.991.738 1.426 1.177a.75.75 0 1 1-1.064 1.057 7.792 7.792 0 0 0-1.197-.987.75.75 0 1 1 .835-1.247z" />
    </g>
  );
};

export default withIcon(IconTimer);
